'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _BarsOutlined = _interopRequireDefault(require('./lib/icons/BarsOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _BarsOutlined;
exports.default = _default;
module.exports = _default;